import { Component } from "@angular/core";

@Component({
  selector: 'app-canteiro-obras',
  templateUrl: './canteiro-obras.component.html',
  styleUrls: ['./canteiro-obras.component.scss']
})
export class CanteiroObrasComponent {

}